import { useEffect } from "react";
import IntercomTracker from "../tracking/Intercom";
import FacebookPixelTracker from "../tracking/FacebookPixel";
import TwitterPixelTracker from "../tracking/TwitterPixel";
import { TRACKING_SCRIPT_DELAY_MS, useDelayAfterLoad } from "../tracking/utils/useDelayAfterLoad";

export const useMarketingPagesTracking = (logFBViewcontent = false) => {
    new IntercomTracker(undefined, false);
    const facebookPixelTracker = new FacebookPixelTracker(null);
    const delayElapsed = useDelayAfterLoad(TRACKING_SCRIPT_DELAY_MS);

    useEffect(() => {
        if (!delayElapsed) return;

        const twitterPixelTracker = new TwitterPixelTracker(null);

        facebookPixelTracker.trackPageView();
        twitterPixelTracker.trackPageView();

        if (logFBViewcontent) {
            facebookPixelTracker.trackEvent("ViewContent");
        }
    }, [delayElapsed]);

    return { facebookPixelTracker };
};
